<template>
    <vs-row vs-justify="center">
        <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="12">
            <vs-card>
                <div slot="header">
                    <h3> <feather-icon icon-pack="feather-icon" icon="UserIcon"></feather-icon> Update Profile</h3>
                </div>
                <form @submit.prevent="submit()">
                    <div class="vx-row mb-2">
                        <div class="vx-col w-full">
                            <vs-input readonly disabled type="text" class="w-full" icon-pack="feather" icon="icon-user" icon-no-border label-placeholder="Username" v-model="username" />
                        </div>
                    </div>
                    <div class="vx-row mb-2">
                        <div class="vx-col w-full">
                            <vs-input readonly disabled type="text" class="w-full" icon-pack="feather" icon="icon-git-pull-request " icon-no-border label-placeholder="Token" v-model="token" />
                        </div>
                    </div>
                    <div class="vx-row mb-2">
                        <div class="vx-col w-full">
                            <vs-input val-icon-danger="warning" :danger="errors.has('new_password')" type="password" class="w-full" icon-pack="feather"  icon="icon-lock" icon-no-border label-placeholder="New Password" v-model="new_password" />
                            <span class="text-danger text-sm" v-show="errors.has('new_password')">{{ errors.first('new_password') }}</span>
                        </div>
                    </div>
                    <div class="vx-row mb-2">
                        <div class="vx-col w-full">
                            <vs-input val-icon-danger="warning" :danger="errors.has('new_password_confirmation')" type="password" class="w-full" icon-pack="feather" icon="icon-lock"  icon-no-border label-placeholder="New Password Confirmation" v-model="new_password_confirmation" />
                            <span class="text-danger text-sm" v-show="errors.has('new_password_confirmation')">{{ errors.first('new_password_confirmation') }}</span>
                        </div>
                    </div>
                    <div class="vx-row mb-2">
                        <div class="vx-col w-full">
                            <vs-input class="w-full" val-icon-danger="warning" :danger="errors.has('company_name')" icon-pack="feather" icon="icon-home" v-validate="'required'" icon-no-border label-placeholder="Company Name" v-model="company_name" />
                            <span class="text-danger text-sm" v-show="errors.has('company_name')">{{ errors.first('company_name') }}</span>
                        </div>
                    </div>
                    <div class="vx-row mb-6">
                        <div class="vx-col w-full">
                            <span style="font-size: 13px;">Logout Other Devices:</span>
                            <vs-switch val-icon-danger="warning" :danger="errors.has('logout_other_devices')" v-validate="'required'"  style="display: inline-flex;position: relative;top: 7px;left: 5px;" class="mt-2" color="success" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" v-model="logout_other_devices">
                                <span slot="on">YES</span>
                                <span slot="off">NO</span>
                            </vs-switch>
                        </div>
                    </div>
                    <div class="vx-row mb-6">
                        <div class="vx-col w-full">
                            <vs-button class="float-right">Update
                                <vs-icon icon="icon-edit" icon-pack="feather"></vs-icon>
                            </vs-button>
                        </div>
                    </div>
                </form>
            </vs-card>
        </vs-col>
    </vs-row>
</template>


<script>
    import Configs from '../../config.js';
    export default {
        data() {
            return {
                username: this.$store.state.AppActiveUser.data.user.username,
                token: this.$store.state.AppActiveUser.data.user.token,
                new_password: null,
                new_password_confirmation: null,
                company_name:this.$store.state.AppActiveUser.data.user.company_name,
                logout_other_devices:false,
            }
        },
        created() {
            this.setBreadCrumbsItems();
        },
        methods: {
            submit(){
                this.$validator.validateAll().then(result => {
                    if (result) {

                        Window.axios({
                            method: 'post',
                            url: Configs.host + '/api/v1/auth/update-profile',
                            data: this.$data,
                            headers: {
                                "Accept": "application/json",
                                "Content-type": "application/json",
                                "Authorization": "Bearer " + this.$store.state.AppActiveUser.token
                            }
                        }).then((response) => {
                            let data = response.data;
                            if(!data.access_token)
                                data.access_token = this.$store.state.AppActiveUser.token;

                            localStorage.setItem('user_data', JSON.stringify(response.data));
                            this.$store.commit('SetAppActiveUser', response.data);
                            this.$vs.notify({
                                title: 'Updated',
                                text: 'You successfully updated your profile',
                                color: 'success',
                                iconPack: 'feather',
                                icon: 'icon-check'
                            });
                            this.$router.push({name: 'dashboard'});
                        }).catch((err) => {
                            this.$setLaravelValidationErrorsFromResponse(err.response.data);
                        })
                    }
                })
            },
            setBreadCrumbsItems() {
                let items = [
                    {
                        title: 'Dashboard',
                        url: '/',
                    },
                    {
                        title: 'Update Profile',
                        active: true
                    }
                ];
                this.$store.commit("SetBreadCrumbsItems", items)
            }
        }
    }
</script>